import React from 'react';
import './contacto.css';
import { getbyID } from "../../modules/datafunction";
import { contacto } from "../../modules/data";
import {container,card} from "../../modules/primecompo";


const getitem0=()=>{

    const cdata=getbyID({item:0},contacto)
    const content0= 
        <div>
            <h1>{cdata['title']} </h1>
        </div>;
    return(container(content0,"row0"))

}
const getitem1=()=>{
    const cdata=getbyID({item:1},contacto)
    const content0= 
        <div>
            <h3>{cdata['h1']}</h3>
            <span>{cdata['span'][0]}</span>
            <p>{cdata['p'][0]}</p>
            <span>{cdata['span'][1]}</span>
            <p>{cdata['p'][1]}</p> 
        </div>;
    const content1=
        <div>
            {cdata['label'].map((item,index)=>(
                <div key={index}>
                    <label>{item}</label>
                    <input type="text" placeholder={item} />
                </div>
            ))}
            <button>{cdata['button']}</button>                               
        </div>  
    return(card(content0,content1,"row0","row0"))
}
const getitem2=()=>{
    const cdata=getbyID({item:2},contacto)
    const content0= 
    <div class="mapouter">
        <div class="gmap_canvas">
        <iframe  width={cdata['width']} 
        height={cdata['height']} 
        src={cdata['map']} className={cdata['class']} ></iframe>
    </div>

    </div>
     
    
  
    return(container(content0,"row0"))

}
const Contacto=()=>{ 

    return(

        <div className="contacto" >

                {getitem0()}
                {getitem1()}
                {getitem2()}
            
            </div>
    )

   }
   

export {Contacto}
